export const GET_DOCUMENTS = "GET_DOCUMENTS"
export const GET_DOCUMENTS_SUCCESS = "GET_DOCUMENTS_SUCCESS"
export const GET_DOCUMENTS_FAIL = "GET_DOCUMENTS_FAIL"

export const GET_DOCUMENTS_ALL = "GET_DOCUMENTS_ALL"
export const GET_DOCUMENTS_ALL_SUCCESS = "GET_DOCUMENTS_ALL_SUCCESS"
export const GET_DOCUMENTS_ALL_FAIL = "GET_DOCUMENTS_ALL_FAIL"

export const CREATE_DOCUMENT = "CREATE_DOCUMENT"
export const CREATE_DOCUMENT_SUCCESS = "CREATE_DOCUMENT_SUCCESS"
export const CREATE_DOCUMENT_FAIL = "CREATE_DOCUMENT_FAIL"

export const GET_DOCUMENT = "GET_DOCUMENT"
export const GET_DOCUMENT_SUCCESS = "GET_DOCUMENT_SUCCESS"
export const GET_DOCUMENT_FAIL = "GET_DOCUMENT_FAIL"

export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT"
export const UPDATE_DOCUMENT_SUCCESS = "UPDATE_DOCUMENT_SUCCESS"
export const UPDATE_DOCUMENT_FAIL = "UPDATE_DOCUMENT_FAIL"

export const DELETE_DOCUMENT = "DELETE_DOCUMENT"
export const DELETE_DOCUMENT_SUCCESS = "DELETE_DOCUMENT_SUCCESS"
export const DELETE_DOCUMENT_FAIL = "DELETE_DOCUMENT_FAIL"

export const GET_COMPANY_DOCUMENTS = "GET_COMPANY_DOCUMENTS"
export const GET_MY_DOCUMENTS = "GET_MY_DOCUMENTS"         
export const ASSIGN_DOCUMENT_COMPANIES = "ASSIGN_DOCUMENT_COMPANIES"
export const ASSIGN_DOCUMENT_COMPANIES_SUCCESS = "ASSIGN_DOCUMENT_COMPANIES_SUCCESS"
export const ASSIGN_DOCUMENT_COMPANIES_FAIL = "ASSIGN_DOCUMENT_COMPANIES_FAIL"

export const CLEAR_DOCUMENT_ERRORS = "CLEAR_DOCUMENT_ERRORS"
export const CLEAR_DOCUMENTS = "CLEAR_DOCUMENTS"
